
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/docs/historical",
      function () {
        return require("private-next-pages/en/docs/historical/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/docs/historical"])
      });
    }
  